// Attach/Detach tracks to/from DOM.

export function attachTrack(track, container) {
  if (!track) return;

  const trackType = track.kind;
  if (!container.querySelector(trackType)) {
    container.appendChild(track.attach());
  }
}

export function detachTrack(track) {
  if (!track) return;

  const attachedElements = track.detach();
  attachedElements.forEach(element => element.remove());
}
